var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6611 4.66454V2.6654C12.6611 2.48867 12.5909 2.31917 12.4659 2.1942C12.3409 2.06923 12.1714 1.99902 11.9947 1.99902H3.33178C2.97831 1.99902 2.63932 2.13944 2.38938 2.38938C2.13944 2.63932 1.99902 2.97831 1.99902 3.33178C1.99902 3.68525 2.13944 4.02424 2.38938 4.27418C2.63932 4.52412 2.97831 4.66454 3.33178 4.66454H13.3275C13.5042 4.66454 13.6737 4.73475 13.7987 4.85972C13.9236 4.98469 13.9938 5.15418 13.9938 5.33092V7.99644M13.9938 7.99644H11.9947C11.6412 7.99644 11.3022 8.13685 11.0523 8.38679C10.8024 8.63673 10.662 8.97572 10.662 9.32919C10.662 9.68266 10.8024 10.0217 11.0523 10.2716C11.3022 10.5215 11.6412 10.662 11.9947 10.662H13.9938C14.1706 10.662 14.3401 10.5917 14.465 10.4668C14.59 10.3418 14.6602 10.1723 14.6602 9.99557V8.66281C14.6602 8.48608 14.59 8.31658 14.465 8.19161C14.3401 8.06664 14.1706 7.99644 13.9938 7.99644Z",
    stroke: "#4A5565",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99902 3.33203V12.6613C1.99902 13.0148 2.13944 13.3538 2.38938 13.6037C2.63932 13.8537 2.97831 13.9941 3.33178 13.9941H13.3275C13.5042 13.9941 13.6737 13.9239 13.7987 13.7989C13.9236 13.6739 13.9938 13.5045 13.9938 13.3277V10.6622",
    stroke: "#4A5565",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1aa05b29fd7baed9c78a225f5f41f915.svg";
export { ForwardRef as ReactComponent };